export const Quality4K = () => {
    return (
        <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.0449 3H1.04492L1.04492 17H26.0449V3ZM1.04492 2C0.492637 2 0.0449219 2.44772 0.0449219 3V17C0.0449219 17.5523 0.492637 18 1.04492 18H26.0449C26.5972 18 27.0449 17.5523 27.0449 17V3C27.0449 2.44772 26.5972 2 26.0449 2H1.04492Z"
                fill="#D1AA6E"
            />
            <path
                d="M9.04492 11H6.04492L9.04492 8V11ZM3.04492 13H9.04492V14H12.0449V13H13.0449V11H12.0449V6H8.04492L3.04492 11V13Z"
                fill="#D1AA6E"
            />
            <path
                d="M20.5449 14H24.5449L20.5909 9.17895L24.5449 6H20.5449L17.0449 9V6H14.0449V14H17.0449V12L18.233 10.9053L20.5449 14Z"
                fill="#D1AA6E"
            />
        </svg>
    );
};
